import React from "react";
import { useNavigate } from "react-router-dom";
import img404 from "../../assets/images/error-404.png";
import "./Error.css";
import { PageSurface } from "../../components/layout/container/Container";

const Error404Page = () => {
  const navigate = useNavigate();

  return (
    <PageSurface className="error-page__container">
      <div className="error-page__content">
        <div className="error-page__img-wrapper">
          <img src={img404} alt="404 - Out of Bounds" className="error-img" />
        </div>

        <div className="error-text-content">
          <span className="error-code">Error 404</span>
          <p className="error-message">
            The page you're looking for doesn't exist or has been moved. Don't
            let the momentum stop here, get back to the action.
          </p>

          <div className="error-actions">
            <button onClick={() => navigate("/")} className="btn-primary-lg">
              Back to Home
            </button>
            <button onClick={() => navigate(-1)} className="btn-secondary-lg">
              Previous Page
            </button>
          </div>
        </div>
      </div>
    </PageSurface>
  );
};

export default Error404Page;
